import React, { useState, useEffect, useRef } from 'react';
import './Testimonials.css';

const reviews = [
  {
    id: 1,
    name: 'Isabelle Moreau',
    title: 'Food Critic, Le Monde',
    stars: 5,
    text: 'I have eaten at 14 of the world\'s 50 best restaurants. Aurum made all of them feel like a practice run. The duck alone justifies the flight from anywhere.',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&auto=format&fit=crop&q=80',
  },
  {
    id: 2,
    name: 'Thomas Eriksson',
    title: 'Verified Guest',
    stars: 5,
    text: 'I booked a table to celebrate my promotion. By dessert, I had forgotten what my job even was. The panna cotta does something to the prefrontal cortex. I am not joking.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&auto=format&fit=crop&q=80',
  },
  {
    id: 3,
    name: 'Priya Nair',
    title: 'Travel & Luxury Blogger',
    stars: 5,
    text: 'I came for the ambiance, stayed for the Wagyu, and left a fundamentally different person. Three stars from Michelin feels conservative. I would give it four dimensions.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&auto=format&fit=crop&q=80',
  },
  {
    id: 4,
    name: 'Arnaud Dupont',
    title: 'Regular Guest since 2020',
    stars: 5,
    text: 'My wife thought I was having an affair because I kept coming here alone. I was — with the truffle bisque. We have resolved our differences. She orders it now too.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&auto=format&fit=crop&q=80',
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const intervalRef = useRef(null);

  const go = (idx) => {
    setActive((idx + reviews.length) % reviews.length);
  };

  useEffect(() => {
    intervalRef.current = setInterval(() => go(active + 1), 5500);
    return () => clearInterval(intervalRef.current);
  }, [active]); // eslint-disable-line

  const review = reviews[active];

  return (
    <section className="testimonials" id="testimonials">
      <div className="testi-bg-left" />

      <div className="section-inner">
        <div className="testi-header reveal">
          <div className="gold-rule">
            <span /><em>Testimonials</em><span />
          </div>
          <h2 className="section-title">
            Heard around <em>the table</em>
          </h2>
        </div>

        <div className="testi-layout">
          {/* Big feature review */}
          <div className="testi-feature reveal delay-2">
            <div className="testi-stars">
              {Array.from({ length: review.stars }).map((_, i) => (
                <span key={i} className="testi-star">✦</span>
              ))}
            </div>
            <blockquote className="testi-quote">
              "{review.text}"
            </blockquote>
            <div className="testi-author">
              <div className="testi-avatar">
                <img src={review.image} alt={review.name} />
              </div>
              <div>
                <span className="testi-name">{review.name}</span>
                <span className="testi-title">{review.title}</span>
              </div>
            </div>

            {/* Controls */}
            <div className="testi-controls">
              <button className="testi-arrow" onClick={() => go(active - 1)} aria-label="Previous">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M13 4l-6 6 6 6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <div className="testi-dots">
                {reviews.map((_, i) => (
                  <button
                    key={i}
                    className={`testi-dot ${i === active ? 'active' : ''}`}
                    onClick={() => { clearInterval(intervalRef.current); go(i); }}
                    aria-label={`Review ${i + 1}`}
                  />
                ))}
              </div>
              <button className="testi-arrow" onClick={() => go(active + 1)} aria-label="Next">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M7 4l6 6-6 6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>

          {/* All reviews thumbs */}
          <div className="testi-list">
            {reviews.map((r, i) => (
              <button
                key={r.id}
                className={`testi-thumb ${i === active ? 'active' : ''}`}
                onClick={() => { clearInterval(intervalRef.current); go(i); }}
              >
                <img src={r.image} alt={r.name} className="thumb-avatar" />
                <div className="thumb-info">
                  <span className="thumb-name">{r.name}</span>
                  <span className="thumb-snippet">
                    "{r.text.slice(0, 60)}…"
                  </span>
                </div>
                <div className="thumb-stars">
                  {Array.from({ length: r.stars }).map((_, si) => (
                    <span key={si}>✦</span>
                  ))}
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}